// extracted by mini-css-extract-plugin
export default {"PdfDropzone":"_PdfDropzone--iCorY","Heading":"_Heading--wlnLG","Loading":"_Loading--swoj0","UploadingError":"_UploadingError--f4Q9B"};